import React from 'react';
import './About.css';

import { Button, Heading} from '../../../components';
import { about } from '../../../constants';
import { FaHammer } from 'react-icons/fa';



const About = () => {

  const { sub, heading, experience, description, points, image, button } = about;

  return (
    <section className="about">

      {/* About Image */}
      <div className="image">
        <div className="sub-image double">
          <img src={image.src1} alt={image.alt1} />
          <img src={image.src2} alt={image.alt2} />
        </div>
        <div className="sub-image last">
          <img src={image.src3} alt={image.alt3} />
          <div className='experience'><span>{experience.year}</span> {experience.text}</div>
        </div>
      </div>

      {/* Introduction Content */}
      <div className="content">

        {/* Section Heading */}
        <Heading title={heading} subTitle={sub} sideHeading />

        {/* Description */}
        {description.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}

        {/* Key Features */}
        <div className="about-features">
          {points.map((point, index) => (
            <ul key={index}>
              <li>
                <div className='icon'><FaHammer /></div> {/* Hammer Icon */}
                <span>{point}</span> {/* Feature Title */}
              </li>
            </ul>
          ))}
        </div>

        {/* Button Component: Links to a specific page or action */}
        <Button link={button.link} title={button.text} />

      </div>
    </section>
  );
};

export default About;